import { jsx as e, jsxs as x } from "react/jsx-runtime";
import { aV as y, w as j } from "../../vendor-Dd6qj6gJ.js";
import { useRef as w } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as L } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as P } from "../FieldDescription/index.js";
import { FieldError as C } from "../FieldError/index.js";
import { SelectFieldLabel as N } from "./SelectFieldLabel/index.js";
import { Surface as R } from "../Surface/index.js";
import { SelectFieldValueProvider as V } from "./SelectFieldContext/index.js";
import { SelectValue as A } from "./SelectValue/index.js";
import { SelectMenuContent as M } from "./SelectFieldContent/index.js";
import { SelectListBox as z } from "./SelectListBox/index.js";
import '../../assets/index53.css';const B = "_selectField_oasyj_1", D = "_popover_oasyj_41", E = "_surface_oasyj_48", t = {
  selectField: B,
  popover: D,
  surface: E
};
function Y({
  label: r,
  errorMessage: d,
  description: n,
  items: l,
  onLoadMore: f,
  placeholder: m,
  search: a,
  "aria-label": c,
  isLoading: p = !1,
  hasMore: h = !0,
  isVirtualized: u = !1,
  fullWidth: v = !1,
  matchTriggerWidth: S = !1,
  startIcon: F,
  horizontal: _ = !1,
  ...o
}) {
  const i = w(null), s = (r ?? c ?? "options").toString().toLocaleLowerCase(), b = m ?? `Choose ${s}`, $ = a?.placeholder ?? `Search ${s}`, g = Array.isArray(o.value) ? o.value.length > 0 : !!o.value;
  return /* @__PURE__ */ e(
    y,
    {
      ...L(o),
      "aria-label": r ? void 0 : c,
      "data-component": "SelectField",
      "data-selection-mode": o.selectionMode,
      "data-has-selection": g || void 0,
      "data-fullwidth": v || void 0,
      "data-horizontal": _ || void 0,
      className: t.selectField,
      children: /* @__PURE__ */ x(V, { items: l, children: [
        /* @__PURE__ */ e(N, { children: r }),
        /* @__PURE__ */ e(A, { ref: i, placeholder: b, startIcon: F }),
        /* @__PURE__ */ e(P, { children: n }),
        /* @__PURE__ */ e(C, { children: d }),
        /* @__PURE__ */ e(j, { className: t.popover, triggerRef: i, children: /* @__PURE__ */ e(
          R,
          {
            className: t.surface,
            "data-match-trigger-width": S || void 0,
            children: /* @__PURE__ */ e(M, { search: a, searchPlaceholder: $, children: /* @__PURE__ */ e(
              z,
              {
                items: l,
                isLoading: p,
                onLoadMore: f,
                hasMore: h,
                isVirtualized: u
              }
            ) })
          }
        ) })
      ] })
    }
  );
}
export {
  Y as SelectField
};
